'use client';

import { useEffect, useRef } from 'react';

import { IS_RUNNING_SERVER_SIDE, IS_PROD_ENVIRONMENT, IS_GHOST_ACCOUNT } from '@/config/app.config';
import { EVENTS } from '@/constants/tracking';
import { identifyLogRocketUser } from '@/lib/logrocket';
import { identifySentry } from '@/lib/sentry';
import { useUserStore } from '@/providers/userStoreProvider';
import { analyticsIdentify, track } from '@/utils/tracker';
import { intercomBoot } from '@/lib/intercom';
import { useShallow } from 'zustand/react/shallow';

const PostAuthInitializers = () => {
  const account = useUserStore(useShallow((state) => state.account));
  const isInitialized = useRef(false);

  const initAnalyticsTracking = async () => {
    await analyticsIdentify(account);
    track(EVENTS.APP_LOADED);
  };

  useEffect(() => {
    if (
      IS_RUNNING_SERVER_SIDE ||
      !IS_PROD_ENVIRONMENT ||
      IS_GHOST_ACCOUNT ||
      !account?.owner ||
      isInitialized.current
    ) {
      return;
    }

    const { owner, email, appKey, appUrl, name } = account;
    identifyLogRocketUser(account);
    identifySentry(email, appKey);
    initAnalyticsTracking();
    intercomBoot({
      app: 'studio',
      user_id: owner,
      email: email,
      name,
      appKey: appKey,
      appUrls: appUrl,
    });

    isInitialized.current = true;
  }, [account]);

  return null;
};

export default PostAuthInitializers;
